import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import config from './config/config';
import { AuthProvider, useAuth } from './contexts/authContext';
import LoginPage from './pages/loginPage';
import RichMenuPage from './pages/richMenu/richMenuPage';
import ModifyRichMenuPage from './pages/richMenu/modifyRichMenuPage';
import PCSegmentPage from './pages/pcSegment/pcSegmentPage';
import PCSegmentDetailPage from './pages/pcSegment/pcSegmentDetailPage';
import TrackingLogPage from './pages/trackingLog/trackingLogPage';
import UserManagementPage from './pages/userManagement/userManagementPage';

// Main App Component
const App: React.FC = () => {
  useEffect(() => {
    // Log app initialization
    config.log('App initialized', 'info');
    config.log(`Environment: ${config.reactAppEnv}`, 'debug');
    config.log(`API URL: ${config.apiUrl}`, 'debug');
  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
};

// App Routes Component with Auth Logic
const AppRoutes: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading while checking authentication
  // if (isLoading) {
  //   return (
  //     <div className="min-h-screen flex items-center justify-center">
  //       <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
  //     </div>
  //   );
  // }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/rich-menu" element={<RichMenuPage />} />
      <Route path="/rich-menu/new" element={<ModifyRichMenuPage />} />
      <Route path="/rich-menu/:id" element={<ModifyRichMenuPage />} />
      <Route path="/pc-segment" element={<PCSegmentPage />} />
      <Route path="/pc-segment/:segmentId" element={<PCSegmentDetailPage />} />
      <Route path="/tracking-log" element={<TrackingLogPage />} />
      <Route path="/user-management" element={<UserManagementPage />} />
      <Route 
        path="/" 
        element={
          isAuthenticated ? 
            <Navigate to="/rich-menu" replace /> : 
            <Navigate to="/login" replace />
        } 
      />
    </Routes>
  );
};

export default App;
